export default "__VITE_ASSET__DHiDUrsj__"